import Image from 'next/image';
import { motion } from 'framer-motion';
import { HButton } from '@/stories/atoms/buttons/mainButton/Button';
import BorderedCard from '@/stories/molecules/cards/borderedCard/BorderedCard';
import { formatFreebetDisplay } from '@/utils/freebet';
import { core } from '../localization/core';
import { useDetectCountry } from '@/src/queries/country/use-detect-country';

type GiftChoices = 'casino' | 'sports' | undefined;
type GiftKey = keyof typeof core.gift.choises;

const diceVariants = {
  initial: { rotate: 0 },
  animate: {
    rotate: [0, 360, 720, 1080, 1440, 1800, 1440, 1080, 720, 360, 0],
    transition: {
      duration: 9,
      ease: [0.83, 0, 0.17, 1],
      repeat: Infinity,
      repeatType: 'loop' as const,
    },
  },
};

const footballVariants = {
  initial: { y: 0 },
  animate: {
    y: [0, -7, 10],
    transition: {
      duration: 1,
      repeat: Infinity,
      repeatType: 'loop' as const,
    },
  },
};

const ContainerGift = ({
  selectedGift, setSelectedGift, setView,
}: { selectedGift: GiftChoices; setSelectedGift: (gift: GiftChoices) => void; setView: (view: GiftChoices) => void; }) => {

  const { data } = useDetectCountry();
  const detectedCountryCode = data?.countryCode ?? 'GLOBAL';

  const freebetText = formatFreebetDisplay(detectedCountryCode);

  const handleClick = (gift: GiftKey) => {
    const giftSelected = core.gift.choises[gift].title === 'PRONOSTICO' ? 'sports' : 'casino';
    setSelectedGift(giftSelected);
  };
  const handleView = (view: GiftChoices) => {
    setView(view);
  };
  return (
    <section className="relative min-h-screen">
      <div className="flex flex-col items-center justify-center gap-8 pt-16">
        <h1 className="text-4xl font-bold font-title text-primary-500">{core.gift.title}</h1>
        <p className="text-center text-lg mt-4 font-text">{core.gift.description}</p>
        <div className="flex  items-center justify-center gap-4 my-4 rounded-lg">
          {(Object.keys(core.gift.choises) as GiftKey[]).map((key) => {
            return (
              <BorderedCard
                key={key}
                isBlurred={false}
                isPressable
                isHoverable={false}
                onPress={() => { return handleClick(key); }}
              >
                <div
                  className=" flex flex-col items-center justify-center w-36 h-40 p-4 pb-5 bg-primary-200/10 bg-blend-saturation"
                >
                  <motion.div
                    variants={key === 'casino' ? diceVariants : footballVariants}
                    initial="initial"
                    animate={selectedGift === (core.gift.choises[key].title === 'PRONOSTICO' ? 'sports' : 'casino') ? 'animate' : 'initial'}
                  >
                    <Image src={core.gift.choises[key].image} alt={key} width={60} height={60} />
                  </motion.div>
                  <h2 className="text-base font-semibold font-text mt-4 bg-linear-to-b from-gradient-50 to-gradient-100 text-transparent bg-clip-text">{core.gift.choises[key].title}</h2>
                  <p className="text-sm font-text">
                    {key === 'sports' ? freebetText : core.gift.choises[key].description}
                  </p>
                </div>
              </BorderedCard>
            );
          })}
        </div>
        <div className="w-3/4 flex items-center justify-center md:w-1/2">
          <HButton label="¡RECLAMA TU REGALO!" size="large" mode="primary" disabled={!selectedGift} onPress={() => { return handleView(selectedGift); }} />
        </div>
      </div>
      <div className="absolute bottom-0 left-0 right-0">
        <p className="text-center text-xs text-white my-2">Copyright © 2025 interplay.tech - Todos los derechos reservados</p>
      </div>
    </section>
  );
};

export default ContainerGift;
